module.exports = __webpack_public_path__ + "static/img/14_pro.4bc0114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/14_pro.jpg
// module id = cTU+
// module chunks = 0